// @flow
import React from 'react';
import injectSheet from 'react-jss';
import ChainSelectorItem from './ChainSelectorItem.jsx';
import { findActiveCategory } from './siteCategories';

type Props = {
  classes: Object,
  path: string,
  rootCategories: Array<Object>,
  disabled: Boolean,
  onPathChange: () => void
}

class ChainSelector extends React.Component {
  props: Props = this.props;

  render() {
    const { classes, path, rootCategories, onPathChange, disabled } = this.props;

    const activeCategory = findActiveCategory(rootCategories, path);
    if (!activeCategory) { return null; }
    const lastItem = activeCategory.path === path;

    return (
      <div className={classes.container}>
        <ChainSelectorItem
          value={activeCategory.path}
          options={rootCategories}
          activeCategory={activeCategory}
          onPathChange={onPathChange}
          showAsButton={!lastItem}
          disabled={disabled}
          lastItem={lastItem}
        />
        {!lastItem && (
          <ChainSelector
            path={path}
            rootCategories={activeCategory.children}
            onPathChange={onPathChange}
            classes={classes}
            disabled={disabled}
          />
        )}
      </div>
    );
  }
}

const styles = {
  container: {
    display: 'flex',
    alignItems: 'center',
    width: '100%'
  }
};

export default injectSheet(styles)(ChainSelector);
